import React from 'react';

const Firebase = React.createContext({
    collection: null,
});

export default Firebase;